module.exports={author:"Mia You",date:"11/10/2019",publishDate:"11/10/2019",highlighted:!1,tags:"",title:"Go Bokito"};